/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1TradingDayEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_INVENTORY_V1_TRADING_DAY_EVENT_ENTITY_NAME = 'ixc.inventory.v1.TradingDayEvent';
export const ixcInventoryV1TradingDayEventEntity = new schema.Entity<IxcInventoryV1TradingDayEvent>(IXC_INVENTORY_V1_TRADING_DAY_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        open: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcInventoryV1TradingDayEvent) => `${entity.metadata?.eventId}` });

